import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignMagazineRoomListPresenter } from "./presenter";
import { useRoomListQuery } from "../../model/repository/query/use-room-list-query";

type Props = {
	hotelID: string;
};

export const DesignMagazineRoomListContainer = memo(({ hotelID }: Props) => {
	const { data } = useRoomListQuery({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignMagazineRoomListPresenter hotelID={hotelID} serverModel={data} />;
});

DesignMagazineRoomListContainer.displayName = "DesignMagazineRoomList";
